// Tiny WebAudio synth for the piggy bank: no audio files, nothing hotlinked.
let ctx = null;

function audio() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

// Browsers start audio suspended until a user gesture; resume quietly on the first tap.
if (typeof window !== "undefined") {
  const unlock = () => { try { audio()?.resume(); } catch (_) { /* blocked: stay silent */ } };
  ["pointerdown", "keydown", "touchstart"].forEach((t) => window.addEventListener(t, unlock, { capture: true, passive: true }));
}

function tone(c, { freq, type = "sine", start = 0, dur = 0.2, gain = 0.2, slideTo, q }) {
  const t0 = c.currentTime + start;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t0);
  if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.008);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  let node = o;
  if (q) {
    const f = c.createBiquadFilter();
    f.type = "lowpass";
    f.frequency.value = q;
    o.connect(f);
    node = f;
  }
  node.connect(g).connect(c.destination);
  o.start(t0);
  o.stop(t0 + dur + 0.05);
}

function noise(c, { start = 0, dur = 0.15, gain = 0.12, hp = 3000 }) {
  const t0 = c.currentTime + start;
  const buf = c.createBuffer(1, Math.ceil(c.sampleRate * dur), c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const s = c.createBufferSource();
  s.buffer = buf;
  const f = c.createBiquadFilter();
  f.type = "highpass";
  f.frequency.value = hp;
  const g = c.createGain();
  g.gain.value = gain;
  s.connect(f).connect(g).connect(c.destination);
  s.start(t0);
}

const SOUNDS = {
  clink: (c, start = 0) => {
    const base = 2200 + Math.random() * 500;
    tone(c, { freq: base, start, dur: 0.18, gain: 0.12, type: "triangle" });
    tone(c, { freq: base * 1.48, start: start + 0.004, dur: 0.12, gain: 0.07 });
    noise(c, { start, dur: 0.03, gain: 0.05, hp: 5000 });
  },
  tumble: (c) => {
    for (let i = 0; i < 6; i++) {
      const s = i * 0.07 + Math.random() * 0.04;
      tone(c, { freq: 1500 + Math.random() * 900, start: s, dur: 0.12, gain: 0.08, type: "triangle" });
      noise(c, { start: s, dur: 0.04, gain: 0.04, hp: 3500 });
    }
  },
  oink: (c) => {
    [0, 0.2].forEach((s) => {
      tone(c, { freq: 210, slideTo: 120, start: s, dur: 0.17, gain: 0.25, type: "sawtooth", q: 900 });
      tone(c, { freq: 420, slideTo: 230, start: s, dur: 0.14, gain: 0.08, type: "square", q: 1200 });
    });
  },
  chaching: (c) => {
    noise(c, { start: 0, dur: 0.12, gain: 0.15, hp: 2500 });
    [1318.5, 1760, 2637].forEach((f, i) => tone(c, { freq: f, start: 0.12 + i * 0.03, dur: 0.9, gain: 0.1 }));
  },
};

export function playSound(name, muted, start = 0) {
  if (muted) return;
  try {
    const c = audio();
    if (!c || c.state !== "running") return;
    SOUNDS[name](c, start);
  } catch (_) { /* audio not allowed: stay silent */ }
}
